import { useEffect, useRef } from "react";
import { GRID_SIZE } from "../../constants/editor";
import type { PixelGrid } from "../../shared/game";

type PixelArtCanvasProps = {
  grid: PixelGrid;
  size: number;
  className?: string;
};

export function PixelArtCanvas({ grid, size, className }: PixelArtCanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext("2d");
    if (!canvas || !context) {
      return;
    }

    const cellSize = size / GRID_SIZE;
    context.clearRect(0, 0, size, size);

    for (let row = 0; row < GRID_SIZE; row += 1) {
      for (let col = 0; col < GRID_SIZE; col += 1) {
        context.fillStyle = grid[row][col] ?? ((row + col) % 2 === 0 ? "#0d0b18" : "#120f1e");
        context.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
      }
    }
  }, [grid, size]);

  return (
    <canvas
      ref={canvasRef}
      width={size}
      height={size}
      className={className}
      style={{ display: "block", width: size, height: size, imageRendering: "pixelated" }}
    />
  );
}
